import * as z from 'zod';
import { Get as Get$2 } from '../../../../surety/bond/contract/contract-surety-bond-mixins.dto.mjs';
import { contractSuretyTypeSchema, dateTimeSchema, suretyBondIssuanceMethodSchema, suretyBondFormTypeSchema, suretyBondStatusSchema, suretyBondRenewalMethodSchema } from '../../../../../enums.mjs';
import '../../../../../types/actor/actor.mjs';
import '../../../../../types/address/address.mjs';
import '../../../../../types/credit-report/company-credit-report.mjs';
import '../../../../../types/credit-report/individual-credit-report.mjs';
import '../../../../../types/currency/currency.mjs';
import '../../../../../types/entityRelation/entity-relation.mjs';
import '../../../../../types/financial-formula/adjustable-value.mjs';
import '../../../../../types/financial-formula/adjustable-values-update.mjs';
import '../../../../../types/financial-formula/adjustment.mjs';
import '../../../../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../../../../types/is-encrypted.mjs';
import '../../../../../types/naics-codes/naics-codes.mjs';
import { userId, companyContactId, sfaaCodeId, suretyAccountId, carrierName, email, lastName, firstName, phoneNumber, percentSchema } from '../../../../../types/opaque.mjs';
import '../../../../../types/surety/account/requested-limits.mjs';
import '../../../../../types/surety/account/surety-account.types.mjs';
import '../../../../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../../../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../../../../types/surety/application-extraction/application-review.mjs';
import { Data as Data$1 } from '../../../../../types/surety/bond/surety-bond.types.mjs';
import '../../../../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../../../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../../../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../../../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../../../../types/surety/contract/contract-extraction-output.mjs';
import '../../../../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../../../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../../../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../../../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../../../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../../../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../../../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../../../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../../../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../../../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../../../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../../../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../../../../types/surety/quote/surety-quote.types.mjs';
import '../../../../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../../../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../../../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../../../../types/user/user.types.mjs';
import { currencySchema } from '../../../../../types/utils.mjs';
import { Data } from '../../../../../types/surety/bond/contract/contract-surety-bond.types.mixins.mjs';
import { Get as Get$1 } from '../admin-surety-bond-mixins.dto.mjs';
import { Obligee } from '../../../../../types/surety/bond/obligee.types.mjs';

var Get;
(function (Get) {
    (function (Response) {
        Response.baseSchema = Get$1.Response.baseSchema
            .extend(Get$2.Response.rawSchema.shape)
            .extend({
            project: Data.projectSchema,
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var Import;
(function (Import) {
    (function (Request) {
        Request.baseSchema = z.object({
            suretyType: z.literal("contract"),
            contractSuretyType: contractSuretyTypeSchema,
            agentId: userId,
            agencyCommissionPercentage: percentSchema.nullish(),
            bond: z.object({
                status: suretyBondStatusSchema,
                number: z.string(),
                bondAmount: currencySchema,
                carrierName: carrierName,
                suretyAccountId: suretyAccountId,
                renewalMethod: suretyBondRenewalMethodSchema.nullish(),
                closedAt: dateTimeSchema.nullish(),
                continuous: z.boolean(),
                cancellable: z.boolean(),
                pointOfContact: z
                    .object({
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                    phone: phoneNumber.nullish(),
                })
                    .nullish(),
                notes: z.string().array().default([]),
                sfaaCodeId,
                companyContactId: companyContactId,
                data: Data$1.schema,
                obligees: Obligee.schema.array(),
            }),
            bondForm: z.object({
                issuanceMethod: suretyBondIssuanceMethodSchema,
                effectiveDate: dateTimeSchema,
                data: z.object({
                    bondFormType: suretyBondFormTypeSchema,
                }),
            }),
        });
    })(Import.Request || (Import.Request = {}));
})(Import || (Import = {}));

export { Get, Import };
